/**
 * Zentrale Liste der "internen" Pfade, auf denen kein Nutzer-Tracking
 * (z. B. Mouseflow Session-Recording) aktiv sein darf.
 *
 * Alles was NICHT hier matcht, gilt als öffentliche Marketing-Seite.
 */
const PRIVATE_PREFIXES = [
  "/admin",
  "/intern",
  "/cockpit",
  "/unsubscribe",
  "/api",
] as const;

export function isPrivateRoute(pathname: string | undefined | null): boolean {
  if (!pathname) return false;
  // Normalisieren: trailing slash entfernen (außer Root)
  const path = pathname.length > 1 && pathname.endsWith("/")
    ? pathname.slice(0, -1)
    : pathname;
  return PRIVATE_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`),
  );
}
